export default __webpack_public_path__ + "static/media/lento_logo.63b77df7.jpg";